import inc from "ramda/src/inc";
import propEq from "ramda/src/propEq";
import pipe from "ramda/src/pipe";
import any from "ramda/src/any";
import filter from "ramda/src/filter";
import propOr from "ramda/src/propOr";
import pick from "ramda/src/pick";
import map from "ramda/src/map";
import { useCallback, useState } from "react";
import useAuth from "../../routes/login/AuthContext";
import { AdminInfo, getAdminUsers } from "../../services/AdminApi";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";

export const useAdminUsers = () => {
  const { getAuthToken } = useAuth();
  const [data, setDate] = useState<AdminInfo[]>([]);
  const [isLoading, setLoading] = useState<boolean>();
  const [isFetched, setFetched] = useState<boolean>(false);
  const { selectedNetworkId } = useSelectedNetworkContext();

  const fetchAdminUsers = async (
    page: null | number = 0,
    users: AdminInfo[] = []
  ): Promise<AdminInfo[]> => {
    if (page === null) return users;

    const res = await getAdminUsers(null, page, await getAuthToken());

    if (!res) return users;

    const totalUsers = users.concat(res?.content);

    return fetchAdminUsers(
      totalUsers.length === res.totalElements ? null : inc(page),
      totalUsers
    );
  };

  const fetch = useCallback(() => {
    setLoading(true);
    fetchAdminUsers()
      .then((
        pipe(
          filter(
            pipe(
              propOr([], 'networks'),
              any((propEq('networkId', selectedNetworkId)))
            )
          ),
          // @ts-ignore
          map(pick(['name', 'email'])),
          setDate
        )
      ))
      .finally(() => {
        setFetched(true);
        setLoading(false);
      });
  }, []);

  return { data, fetch, isFetched, isLoading };
};
